export enum PolicyFilterTag {
  GLOBAL = 'global',
  MGA = 'mga',
  RENEWALS = 'renewals',
  ACTIVITIES = 'activities',
}
